import React from 'react';
import { ContentLayout, Spinner } from 'bv-components';
import { remove } from 'bv-local-storage';
import { setLocation } from 'location-helper';

export default () => {
  remove('stakes');
  remove('resumeToken');
  setLocation('/logout');
  return (
    <ContentLayout>
      <Spinner />
    </ContentLayout>
  );
};
